// Phase 43 (item 4) — XLSX cell coercion shared by BOTH client importers
// (standalone CII in App.jsx and the CCV roster ClImp). The archived flag and
// its date are INGESTED from the source columns (D18) — never invented.
// PURE: no React/DOM/network.

// Boolean cells arrive as true/false, 1/0, or a word ("yes"/"x"/"archived"/…).
export function parseBoolCell(v) {
  if (v == null || v === "") return false;
  if (typeof v === "boolean") return v;
  if (typeof v === "number") return v !== 0;
  const s = String(v).trim().toLowerCase();
  return [
    "1", "true", "yes", "y", "x",
    "oui", "vrai",
    "ja", "waar",
    "archived", "archivé", "archive", "gearchiveerd",
  ].includes(s);
}

// Date cells arrive as an ISO string, a day-first dd/mm/yyyy string (Belgian
// convention), or an Excel serial day-number. Returns an ISO datetime string or
// null. Never defaults to "now" — an unparseable/blank cell yields null.
export function parseDateCell(v) {
  if (v == null || v === "") return null;
  if (v instanceof Date) return isNaN(v.getTime()) ? null : v.toISOString();
  if (typeof v === "number" && isFinite(v)) {
    // Excel serial date = days since 1899-12-30. Guard an obviously-non-date int.
    if (v > 59 && v < 80000) {
      const d = new Date(Math.round((v - 25569) * 86400 * 1000));
      return isNaN(d.getTime()) ? null : d.toISOString();
    }
    return null;
  }
  const s = String(v).trim();
  if (!s) return null;
  // dd/mm/yyyy | dd-mm-yyyy | dd.mm.yyyy → yyyy-mm-dd (day-first, Belgian).
  const m = s.match(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})$/);
  if (m) {
    const iso = `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}`;
    const dt = new Date(iso);
    return isNaN(dt.getTime()) ? null : dt.toISOString();
  }
  const dt = new Date(s);
  return isNaN(dt.getTime()) ? null : dt.toISOString();
}
